import React from 'react';
import { Col, Collapse, Row } from '@digitools/honest-react';
import { useTranslation } from 'react-i18next';
// @ts-ignore
import styles from './Payment.scss';
const DataRow = ({ label, value, ...rest }) => {
    return (<Row className={'mr-0'}>
      <Col>{label}</Col>
      <Col style={{ textAlign: 'right' }} {...rest}>
        {value}
      </Col>
    </Row>);
};
const CheckDetailsMobile = ({ checkData }) => {
    const { t } = useTranslation();
    return (<Row data-testid='payment-list-mobile-details-collapsible'>
      <Col>
        <Collapse title={`${t('checkDetailsHeaderText')}`}>
          <DataRow label={t('checkTotalOffsetAmountText')} value={checkData.totalOffsetDeductions ? checkData.totalOffsetDeductions : '$0'} data-private={true}/>
          <DataRow label={t('checkAdjustedBenefitGrossAmountText')} value={checkData.adjustedBenefitGross} data-private={true}/>
          <DataRow label={t('colaAmountText')} value={checkData.cola} data-private={true}/>
          <Row>
            <Col>
              <Collapse title={`${t('checkTaxWithheldAmountText')}`} headerRightDisplay={() => <span data-private={true}>{checkData.totalTaxWithheld}</span>}>
                <DataRow label={`${t('checkFederalTaxWithheldAmountText')}`} value={checkData.totalFederalTaxWithheld} data-private={true}/>
                <DataRow label={`${t('checkStateTaxWithheldAmountText')}`} value={checkData.totalStateTaxWithheld} data-private={true}/>
                <DataRow label={`${t('checkLoclTaxWithheldAmountText')}`} value={checkData.localTaxWithheld} data-private={true}/>
                <DataRow label={<strong>{`${t('checkFicaTaxWithheldAmountText')}`}</strong>} value={checkData.ficaTaxWithheld} data-private={true}/>
                <DataRow label={<div className={styles.ficaTab}>{`${t('checkSsoaiTaxWithheldAmountText')}`}</div>} value={checkData.ssoaiTaxWithheld} data-private={true}/>
                <DataRow label={<div className={styles.ficaTab}>{`${t('checkMedicareTaxWithheldAmountText')}`}</div>} value={checkData.medicareTaxWithheld} data-private={true}/>
              </Collapse>

              <Collapse title={`${t('checkTotalDeductionAmountText')}`} headerRightDisplay={() => <span data-private={true}>{checkData.totalOtherDeductions}</span>}>
                {checkData.checkOtherDeductions &&
            checkData.checkOtherDeductions.length > 0 &&
            checkData.checkOtherDeductions.map((otherDeduction) => (<>
                      <DataRow data-private={true} label={'Begin Date'} value={otherDeduction.fromDate}/>
                      <DataRow data-private={true} label={'End Date'} value={otherDeduction.throughDate}/>
                      <DataRow label={'Reason'} value={otherDeduction.reason}/>
                      <DataRow data-private={true} label={'Amount'} value={otherDeduction.amount}/>
                      <hr />
                    </>))}
                {(!checkData.checkOtherDeductions || checkData.checkOtherDeductions.length <= 0) && (<span>{t('noInformationText').toString()}</span>)}
              </Collapse>
              <Collapse title={`${t('checkTotalOffsetAmountText')}`} headerRightDisplay={() => <span data-private={true}>{checkData.totalOffsetDeductions}</span>}>
                {checkData.checkOffsetDeductions &&
            checkData.checkOffsetDeductions.length > 0 &&
            checkData.checkOffsetDeductions.map((offsetDeduction) => (<>
                      <DataRow data-private={true} label={'Begin Date'} value={offsetDeduction.fromDate}/>
                      <DataRow data-private={true} label={'End Date'} value={offsetDeduction.throughDate}/>
                      <DataRow label={'Reason'} value={offsetDeduction.reason}/>
                      <DataRow data-private={true} label={'Amount'} value={offsetDeduction.amount}/>
                      <hr />
                    </>))}
                {(!checkData.checkOffsetDeductions || checkData.checkOffsetDeductions.length <= 0) && (<span>{t('noInformationText').toString()}</span>)}
              </Collapse>
              <Row style={{ marginTop: '.5rem' }}>
                <Col>
                  <DataRow label={<strong>Wages</strong>} value={<strong>Taxable</strong>}/>
                  <DataRow data-private={true} label={'Federal'} value={checkData.federalWage}/>
                  <DataRow data-private={true} label={'Medicare'} value={checkData.medicareWage}/>
                  <DataRow data-private={true} label={'OASDI'} value={checkData.ssoiWage}/>
                  <DataRow data-private={true} label={'State'} value={checkData.stateWage}/>
                  <DataRow label={''} value={<strong>Non-Taxable</strong>}/>
                  <DataRow data-private={true} label={'Federal'} value={checkData.nonTaxableFederal}/>
                </Col>
              </Row>
            </Col>
          </Row>
        </Collapse>
      </Col>
    </Row>);
};
export default CheckDetailsMobile;
